/* TK product page (loaded on product pages from layout/theme.liquid; styles in assets/tk-product.css).
   1. Measurement for the CSS: --tk-pdp-hdr (the header's height, where the sticky desktop info panel stops); the
      title shrunk when a single word is too wide; the desktop thumbnail strip beside the pictures; gallery videos
      playing while in view; the Redo "Try it on" button matched to the theme's buttons.
   2. "Pairs well with" (snippets/tk-pairs-well-block.liquid) loads its items from sections/tk-pairs-well.liquid; it and
      "Available also in" (snippets/tk-also-in-block.liquid) add the tapped size straight to the bag, the same way the theme's own buttons do (bag drawer updated and opened,
      bag count refreshed). */
(function () {
  if (window.__tkProduct) return;
  window.__tkProduct = true;

  /* ---------- 1. measurement ---------- */
  function measure() {
    var root = document.documentElement;
    var header = document.querySelector('header.site-header');
    var section = header && (header.closest('.shopify-section') || header);
    if (section) root.style.setProperty('--tk-pdp-hdr', section.offsetHeight + 'px');
  }
  measure();
  window.addEventListener('load', measure);
  window.addEventListener('resize', measure);

  /* ---------- title: as big as the collection page title, shrunk only when one word is too wide for the panel ---------- */
  function fitTitle() {
    var h = document.querySelector('.template-product .tk-pdp-title__h');
    if (!h) return;
    var name = h.querySelector('.tk-pdp-title__name') || h;
    /* the theme's text styles would split the word mid-way (SWEATPAN-TS); keep words whole and shrink instead */
    [h, name].forEach(function (el) {
      el.style.overflowWrap = 'normal';
      el.style.wordBreak = 'normal';
      el.style.hyphens = 'manual';
    });
    h.style.fontSize = '';
    var size = parseFloat(getComputedStyle(h).fontSize);
    var guard = 0;
    while (name.scrollWidth > name.clientWidth + 1 && size > 24 && guard < 40) {
      size -= 2;
      h.style.fontSize = size + 'px';
      guard++;
    }
  }
  fitTitle();
  window.addEventListener('load', fitTitle);
  window.addEventListener('resize', fitTitle);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitle);

  /* ---------- phone gallery: open on the first photo and stay put when a size is picked ----------
     The theme opens the gallery on the selected variant's image and jumps to it whenever a size is picked. Here every
     size of a product shares the same pictures (colours are separate products), so that only ever lands on the
     pack shot: start on the first photo instead, and put the gallery back where it was after a size change. */
  function mobileSwiper() {
    var el = document.querySelector('#productMediaMobile .swiper');
    return el && el.swiper;
  }
  function resetGallery(tries) {
    var sw = mobileSwiper();
    if (sw) { if (sw.activeIndex !== 0) sw.slideTo(0, 0); return; }
    if (tries > 0) setTimeout(function () { resetGallery(tries - 1); }, 150);
  }
  window.addEventListener('load', function () { resetGallery(20); });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.closest || !input.closest('product-information')) return;
    if (input.closest('.linked-products-swatch')) return;
    var sw = mobileSwiper();
    if (!sw) return;
    var keep = sw.activeIndex;
    [60, 300, 900].forEach(function (ms) {
      setTimeout(function () {
        var now = mobileSwiper();
        if (now && now.activeIndex !== keep) now.slideTo(keep, 0);
      }, ms);
    });
  }, true);

  /* ---------- collapsible tabs stay open when a size is picked ----------
     TK (product page fixes): on every size change the theme's product-information (component-product-information.js,
     replaceElements) re-renders the info panel and copies the new HTML into every element with a data-update-id,
     including the Details / Size & Fit / Measurements tabs (sections/template--product.liquid, 'collapsible-tab'), so
     an open tab snapped shut. Their content doesn't change with the size, so the tabs are taken out of that update:
     the id is removed from the tabs on the page and from the freshly fetched HTML right before the theme compares
     them (with the id gone on both sides the theme neither replaces nor re-adds them). Colours are separate products
     here (no combined listings), so the tabs never need to change without a page load. Same effect as removing
     data-updates-on-change / data-update-id from the collapsible-tab markup in the section. */
  function tkUntrackTabs(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.collapsible-tab-container[data-update-id]').forEach(function (el) {
      el.removeAttribute('data-update-id');
      el.removeAttribute('data-updates-on-change');
    });
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-information').then(function () {
      var PI = customElements.get('product-information');
      var proto = PI && PI.prototype;
      if (!proto || typeof proto.replaceElements !== 'function' || proto.__tkTabsKept) return;
      var original = proto.replaceElements;
      proto.replaceElements = function (html) {
        try { tkUntrackTabs(html); tkUntrackTabs(this); } catch (e) {}
        return original.apply(this, arguments);
      };
      proto.__tkTabsKept = true;
    });
  }

  /* ---------- desktop thumbnail strip ----------
     A column of small pictures beside the desktop gallery (styled in tk-product.css as .tk-thumbs). Tapping one scrolls
     to that picture; the one in view is outlined. Built from the gallery itself, in the order the pictures show. */
  function galleryItems(grid) {
    var main = grid.querySelector('[data-media-main]');
    if (!main) return [];
    var odd = main.querySelector('.media-column--odd');
    var even = main.querySelector('.media-column--even');
    var full = main.querySelector('.media-column--odd-full');
    /* only the media themselves: a column can start with a stylesheet <link> (it does when the first media is a video) */
    var media = function (col) {
      return col ? Array.prototype.filter.call(col.children, function (el) { return !/^(LINK|SCRIPT|STYLE|TEMPLATE)$/.test(el.tagName); }) : [];
    };
    var a = media(odd);
    var b = media(even);
    var items = [];
    for (var i = 0; i < Math.max(a.length, b.length); i++) {
      if (a[i]) items.push(a[i]);
      if (b[i]) items.push(b[i]);
    }
    if (full) items = items.concat(media(full));
    if (!items.length) items = Array.prototype.slice.call(main.querySelectorAll('[data-main-media-link], .product-single__media__wrapper'));
    return items.filter(function (el) { return el.offsetParent !== null || el.getClientRects().length; });
  }

  function thumbSrc(item) {
    var img = item.querySelector('img');
    var srcset = img && (img.getAttribute('srcset') || img.getAttribute('data-srcset'));
    var src = img && (img.currentSrc || (srcset && srcset.trim().split(/\s+/)[0]) || img.getAttribute('src'));
    if (src && src.indexOf('data:') === 0) src = '';
    if (!src) {
      var video = item.querySelector('video[poster]');
      src = video && video.getAttribute('poster');
    }
    if (!src) return '';
    return src.replace(/([?&])width=\d+/, '$1width=180').replace(/^\/\//, 'https://');
  }

  var thumbsState = null;
  function buildThumbs() {
    var grid = document.querySelector('.template-product product-media-grid');
    if (!grid) return;
    var items = galleryItems(grid);
    var old = grid.querySelector('.tk-thumbs');
    if (old) old.remove();
    thumbsState = null;
    if (items.length < 2) return;

    var nav = document.createElement('nav');
    nav.className = 'tk-thumbs';
    nav.setAttribute('aria-label', 'Product images');
    items.forEach(function (item, i) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tk-thumbs__btn';
      button.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + items.length);
      button.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      var src = thumbSrc(item);
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.width = 58;
        img.height = 87;
        img.loading = i < 8 ? 'eager' : 'lazy';
        button.appendChild(img);
      }
      button.addEventListener('click', function () {
        var top = item.getBoundingClientRect().top + window.scrollY;
        /* the header slides away when scrolling down and back in when scrolling up */
        var header = top < window.scrollY ? (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tk-pdp-hdr')) || 0) : 0;
        window.scrollTo({ top: Math.max(0, top - header), behavior: 'smooth' });
      });
      nav.appendChild(button);
    });
    grid.insertBefore(nav, grid.firstChild);
    thumbsState = { items: items, buttons: Array.prototype.slice.call(nav.children), nav: nav, current: 0 };
    markThumb();
  }

  function markThumb() {
    var s = thumbsState;
    if (!s || !s.nav.isConnected || !s.nav.offsetParent) return;
    var line = window.innerHeight * 0.4;
    var current = 0;
    for (var i = 0; i < s.items.length; i++) {
      if (s.items[i].getBoundingClientRect().top <= line) current = i;
    }
    if (current === s.current) return;
    s.buttons[s.current].setAttribute('aria-current', 'false');
    s.buttons[current].setAttribute('aria-current', 'true');
    s.current = current;
    /* keep the outlined thumbnail visible when the strip itself is taller than the screen */
    var b = s.buttons[current];
    if (b.offsetTop < s.nav.scrollTop || b.offsetTop + b.offsetHeight > s.nav.scrollTop + s.nav.clientHeight) {
      s.nav.scrollTo({ top: b.offsetTop - 8, behavior: 'smooth' });
    }
  }

  var thumbsTick = false;
  window.addEventListener('scroll', function () {
    if (thumbsTick) return;
    thumbsTick = true;
    requestAnimationFrame(function () { thumbsTick = false; markThumb(); });
  }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildThumbs);
  else buildThumbs();
  window.addEventListener('resize', function () {
    if (!thumbsState && window.matchMedia('(min-width: 990px)').matches) buildThumbs();
  });
  /* if the theme swaps the gallery (another variant), build the strip again */
  (function watchGallery() {
    var grid = document.querySelector('.template-product product-media-grid [data-media-main]');
    if (!grid || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; buildThumbs(); }, 100);
    }).observe(grid, { childList: true, subtree: true });
  })();

  /* ---------- gallery videos: play when in view ----------
     The theme keeps two copies of each product video, one in the desktop gallery and one in the phone slider (only
     one of them is showing). Each copy pauses every other video when it starts, so whichever loads last wins and it
     is usually the hidden one: the video you can see stops. The theme's gallery also pauses all videos whenever the
     window resizes. So: only ONE video plays, the most visible one in the gallery that's showing (muted, looping, at
     least a third of it on screen); every other copy is paused.
     TK (product page fixes): two adjacent desktop videos used to fight (both wanted to play, each start paused the
     other through the theme's "media:play:global" event), so only the single most visible one is picked now. The old
     "the shopper paused it" flag is gone: gallery videos behave like moving pictures, and a tap no longer toggles
     them (the theme paused on tap and this script restarted it 30ms later, so it stuttered). Shoppers who ask for
     reduced motion get no autoplay; for them the theme's tap-to-play/pause is left as it was. */
  var VIDEO_SEL = '.template-product product-media-grid video, .template-product #productMediaMobile video';
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var videoTick = false;
  function isShown(el) { return !!(el.offsetParent || el.getClientRects().length); }
  function syncVideos() {
    videoTick = false;
    var vh = window.innerHeight;
    var videos = Array.prototype.slice.call(document.querySelectorAll(VIDEO_SEL));
    if (reduceMotion.matches) {
      /* no autoplay: stop each video once when it first loads, then leave it to the shopper */
      videos.forEach(function (v) {
        if (v.dataset.tkRm === '1') return;
        v.dataset.tkRm = '1';
        v.autoplay = false;
        if (!v.paused) v.pause();
      });
      return;
    }
    /* TK: the theme only creates a gallery video (poster + play button until then) when its phone slider reports
       "ready"; on desktop that signal doesn't reach the gallery, so the video stayed a poster with a play button.
       Start the most visible gallery video that isn't loaded yet ourselves (same as the shopper pressing play). */
    var dmBest = null;
    var dmSeen = 0.33;
    document.querySelectorAll('.template-product product-media-grid deferred-media, .template-product #productMediaMobile deferred-media').forEach(function (dm) {
      if (dm.getAttribute('data-media-loaded') || dm.dataset.tkLoading === '1' || dm.querySelector('video, iframe')) return;
      var slide = dm.closest('.swiper-slide');
      if (!isShown(dm) || (slide && !slide.classList.contains('swiper-slide-active'))) return;
      var r = dm.getBoundingClientRect();
      if (r.height <= 0) return;
      var seen = (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
      if (seen >= dmSeen) { dmBest = dm; dmSeen = seen; }
    });
    if (dmBest) {
      dmBest.dataset.tkLoading = '1';
      if (typeof dmBest.loadMedia === 'function') dmBest.loadMedia();
      else { var playBtn = dmBest.querySelector('button'); if (playBtn) playBtn.click(); }
      [300, 1000].forEach(function (ms) { setTimeout(queueVideos, ms); });
    }
    var best = null;
    var bestSeen = 0.33;
    videos.forEach(function (v) {
      var slide = v.closest('.swiper-slide');
      if (!isShown(v) || (slide && !slide.classList.contains('swiper-slide-active'))) return;
      var r = v.getBoundingClientRect();
      if (r.height <= 0) return;
      var seen = (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
      if (seen >= bestSeen) { best = v; bestSeen = seen; }
    });
    videos.forEach(function (v) {
      if (v !== best && !v.paused) v.pause();
    });
    if (best) {
      best.muted = true;
      best.loop = true;
      best.playsInline = true;
      best.controls = false;
      if (best.paused) {
        var p = best.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
  }
  function queueVideos() {
    if (videoTick) return;
    videoTick = true;
    setTimeout(syncVideos, 16);
  }
  window.addEventListener('scroll', queueVideos, { passive: true });
  window.addEventListener('resize', function () { setTimeout(queueVideos, 60); });
  window.addEventListener('load', function () { [0, 400, 1200, 2500].forEach(function (ms) { setTimeout(queueVideos, ms); }); });
  /* the theme pauses and plays videos from its own scripts: put back the one that should be playing */
  document.addEventListener('pause', function (event) {
    if (event.target && event.target.tagName === 'VIDEO') setTimeout(queueVideos, 30);
  }, true);
  document.addEventListener('play', function (event) {
    var v = event.target;
    if (!v || v.tagName !== 'VIDEO') return;
    /* reduced motion: the theme calls play() as soon as a video loads; only a tap may start it */
    if (reduceMotion.matches && v.matches && v.matches(VIDEO_SEL) && v.dataset.tkTapPlay !== '1') { v.pause(); return; }
    setTimeout(queueVideos, 30);
  }, true);
  /* a tap on a gallery video: the theme (component-deferred-media.js, setupVideoToggle) toggles play/pause with a
     click listener on the <video> itself. Stop the click here, in the capture phase, before it reaches the video.
     Videos are not inside the gallery's [data-main-media-link] photo links, so no zoom/lightbox is lost. */
  document.addEventListener('click', function (event) {
    var v = event.target && event.target.closest && event.target.closest(VIDEO_SEL);
    if (!v) return;
    if (reduceMotion.matches) { v.dataset.tkTapPlay = '1'; return; }
    event.stopPropagation();
    event.preventDefault();
    /* a tap may start a video the browser refused to autoplay (e.g. iPhone Low Power Mode), never pause one */
    if (v.paused) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }, true);
  /* the phone slider: check again whenever the shown photo changes */
  document.addEventListener('transitionend', function (event) {
    if (event.target && event.target.closest && event.target.closest('#productMediaMobile')) queueVideos();
  }, true);
  /* a video loaded later (the theme adds it on demand) */
  if (window.MutationObserver) {
    document.querySelectorAll('.template-product product-media-grid, .template-product #productMediaMobile').forEach(function (g) {
      new MutationObserver(queueVideos).observe(g, { childList: true, subtree: true });
    });
  }

  /* ---------- Redo "Try it on" button: styled like the theme's buttons ----------
     The Redo app draws its button inside its own shadow root with inline styles (black, 16px, rounded), so the page's
     CSS can't reach it. A small stylesheet goes into that shadow root instead: the same height, corner radius and
     type as Add to bag, as the outlined second button (white with a black border, black on hover) so Add to bag stays
     the main action. */
  function styleTryOn() {
    var add = document.querySelector('product-information [name="add"], product-information button[type="submit"]');
    document.querySelectorAll('redo-try-it-on-button-container-element').forEach(function (host) {
      var root = host.shadowRoot;
      if (!root || !root.querySelector('button')) return;
      var cs = add ? getComputedStyle(add) : null;
      var css =
        'button{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;' +
        'width:100%!important;height:' + (add && add.offsetHeight ? add.offsetHeight : 48) + 'px!important;margin:0!important;padding:0 16px!important;' +
        'background:#fff!important;color:#000!important;border:1px solid #000!important;border-radius:' + (cs ? cs.borderRadius : '2px') + '!important;' +
        'box-shadow:none!important;font-family:' + (cs ? cs.fontFamily.replace(/"/g, "'") : 'inherit') + '!important;font-size:12px!important;' +
        'font-weight:700!important;line-height:1!important;letter-spacing:1px!important;text-transform:uppercase!important;cursor:pointer;' +
        /* TK: no Redo fade-in (its .2s transition made a grey step while the colours changed) */
        'opacity:1!important;animation:none!important;transition:background-color .15s ease,color .15s ease!important}' +
        'button:hover{background:#000!important;color:#fff!important}' +
        'button:focus-visible{outline:1px solid #000!important;outline-offset:2px!important}' +
        'button svg{width:14px!important;height:14px!important;flex:0 0 auto}';
      var style = root.querySelector('style[data-tk-tryon]');
      if (!style) {
        style = document.createElement('style');
        style.setAttribute('data-tk-tryon', '');
        root.appendChild(style);
      }
      if (style.textContent !== css) style.textContent = css;
      if (!host.__tkWatched && window.MutationObserver) {
        host.__tkWatched = true;
        new MutationObserver(function () { if (!root.querySelector('style[data-tk-tryon]')) styleTryOn(); }).observe(root, { childList: true });
      }
    });
  }
  [0, 500, 1500, 3000, 6000].forEach(function (ms) { setTimeout(styleTryOn, ms); });
  window.addEventListener('load', styleTryOn);
  window.addEventListener('resize', function () { setTimeout(styleTryOn, 100); });
  /* TK: style the button in the same frame Redo draws it (checked every frame for the first 8 seconds), instead of
     waiting for the next timer above. The Redo block settings in templates/product.json already draw it white, outlined
     and uppercase, so this mostly matches the font and height to Add to bag. */
  (function watchTryOn() {
    var until = Date.now() + 8000;
    (function tick() {
      document.querySelectorAll('redo-try-it-on-button-container-element').forEach(function (host) {
        var root = host.shadowRoot;
        if (root && root.querySelector('button') && !root.querySelector('style[data-tk-tryon]')) styleTryOn();
      });
      if (Date.now() < until) window.requestAnimationFrame(tick);
    })();
  })();
  /* TK: the Try it on block keeps 44px from the first paint (tk-product.css) so nothing jumps when Redo draws it;
     give that space back on products where Redo shows no button. */
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('product-information .shopify-app-block[id*="__redo_try_it_on_button_"]').forEach(function (block) {
        var host = block.querySelector('redo-try-it-on-button-container-element');
        var btn = host && host.shadowRoot && host.shadowRoot.querySelector('button');
        if (!btn || !btn.offsetHeight) block.classList.add('tk-tryon-none');
      });
    }, 4000);
  });

  /* ---------- Sticky product info, full height ----------
     The theme's top (inline, under the header) is used when the panel fits on screen. When it is taller than the screen,
     top goes negative by the difference, so the panel scrolls with the page until its bottom is 24px above the bottom
     of the screen and sticks there: nothing is ever cut off and there is no scroll box inside the panel. Re-measured
     when the panel changes height (a tab opens, a size message appears) and on resize. CSS: tk-product.css. */
  (function stickyInfo() {
    var pi = document.querySelector('.template-product product-information.product-sticky');
    if (!pi) return;
    var wide = window.matchMedia('(min-width: 768px)');
    var queued = false;
    var measure = function () {
      queued = false;
      var rootStyle = document.documentElement.style; // on <html>, not the panel, so the style watcher below doesn't loop
      if (!wide.matches) { rootStyle.removeProperty('--tk-pdp-sticky-top'); return; }
      // base = the usual "just under the header" top (--tk-pdp-hdr, set elsewhere in this file), else the theme's inline top
      var base = parseFloat(getComputedStyle(pi).getPropertyValue('--tk-pdp-hdr'));
      if (!(base >= 0)) base = parseFloat(pi.style.top);
      if (!(base >= 0)) base = 80;
      var top = Math.min(base, window.innerHeight - pi.offsetHeight - 24);
      var v = Math.round(top) + 'px';
      if (rootStyle.getPropertyValue('--tk-pdp-sticky-top') !== v) rootStyle.setProperty('--tk-pdp-sticky-top', v);
    };
    var queue = function () { if (!queued) { queued = true; window.requestAnimationFrame(measure); } };
    measure();
    window.addEventListener('resize', queue);
    window.addEventListener('load', measure);
    if (window.ResizeObserver) new ResizeObserver(queue).observe(pi);
    // the theme rewrites the inline top when the header changes size; follow it
    if (window.MutationObserver) new MutationObserver(queue).observe(pi, { attributes: true, attributeFilter: ['style'] });
  })();

  /* ---------- 2. Pairs well with: quick add ---------- */
  function setStatus(item, text) {
    var status = item && item.querySelector('.tkpw__status');
    if (status) status.textContent = text;
  }

  var FRIENDLY_ADD_ERROR = "Couldn't add to bag. Please try again.";
  async function addToBag(button) {
    var item = button.closest('.tkpw__item');
    var id = button.getAttribute('data-tkpw-add');
    if (!id || button.disabled || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    setStatus(item, '');

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer) body.sections = 'cart-drawer';

    try {
      var res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      /* TK (product page fixes): read the reply as text first; an error page (HTML) used to surface as
         "Unexpected token <" when parsed as JSON. Shopify's own error text is kept when it sends one. */
      var text = await res.text();
      var json = null;
      try { json = text ? JSON.parse(text) : null; } catch (parseErr) { json = null; }
      if (!res.ok || !json) {
        var failed = new Error((json && (json.description || json.message)) || FRIENDLY_ADD_ERROR);
        failed.tkFriendly = true;
        throw failed;
      }

      if (window.eventBus) {
        if (drawer) window.eventBus.emit('update:cart:drawer', json);
        window.eventBus.emit('cart:added', json);
      }
      /* TK: the item is already in the bag here; a failed count refresh must not show an error */
      try {
        var cart = await (await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')).json();
        if (window.wetheme && typeof window.wetheme.updateCartCount === 'function') window.wetheme.updateCartCount(cart);
      } catch (countErr) {}

      button.classList.add('is-added');
      setStatus(item, 'Added to bag');
      if (drawer && window.eventBus) window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      else if (!drawer) window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      setTimeout(function () { button.classList.remove('is-added'); setStatus(item, ''); }, 2500);
    } catch (err) {
      /* only messages written for shoppers (ours or Shopify's) are shown; network/script errors get the friendly one */
      setStatus(item, err && err.tkFriendly && err.message ? err.message : FRIENDLY_ADD_ERROR);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-tkpw-add]');
    if (!button || !button.closest('.tkpw')) return;
    event.preventDefault();
    addToBag(button);
  });

  if (!customElements.get('tk-pairs-well')) {
    customElements.define('tk-pairs-well', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        var self = this;
        var url = this.getAttribute('data-url');
        if (!url) return;
        fetch(url)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var list = new DOMParser().parseFromString(html, 'text/html').querySelector('.tkpw__list');
            if (!list || !list.children.length) return;
            self.querySelector('.tkpw__slot').appendChild(document.importNode(list, true));
            self.hidden = false;
          })
          .catch(function () {});
      }
    });
  }
})();
